import * as React from "react";

const SvgIcnQueuesBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <path
                d="M5 4h14a2 2 0 012 2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V6a2 2 0 012-2zm7.5 10h5a.5.5 0 100-1h-5a.5.5 0 100 1zm0-6h5a.5.5 0 100-1h-5a.5.5 0 100 1zm0 8H16a.5.5 0 100-1h-3.5a.5.5 0 100 1zm0-6H16a.5.5 0 100-1h-3.5a.5.5 0 100 1zm-4 0a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0 5a1.5 1.5 0 110-3 1.5 1.5 0 010 3zm0 1a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
                fill="currentColor"
            />
            <path d="M6.5 20.5h11" stroke="currentColor" strokeLinecap="round" />
        </g>
    </svg>
);

export default SvgIcnQueuesBold;
